/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TemplatesRouteImport } from './routes/templates'
import { Route as SplatRouteImport } from './routes/$'
import { Route as IndexRouteImport } from './routes/index'
import { Route as IdSummariseRouteImport } from './routes/$id/summarise'
import { Route as IdActionsRouteImport } from './routes/$id/actions'
import { Route as TemplatesTemplateIdEditRouteImport } from './routes/templates_.$templateId.edit'

const TemplatesRoute = TemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const IdSummariseRoute = IdSummariseRouteImport.update({
  id: '/$id/summarise',
  path: '/$id/summarise',
  getParentRoute: () => rootRouteImport,
} as any)
const IdActionsRoute = IdActionsRouteImport.update({
  id: '/$id/actions',
  path: '/$id/actions',
  getParentRoute: () => rootRouteImport,
} as any)
const TemplatesTemplateIdEditRoute = TemplatesTemplateIdEditRouteImport.update({
  id: '/templates_/$templateId/edit',
  path: '/templates/$templateId/edit',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/templates': typeof TemplatesRoute
  '/$id/actions': typeof IdActionsRoute
  '/$id/summarise': typeof IdSummariseRoute
  '/templates/$templateId/edit': typeof TemplatesTemplateIdEditRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/templates': typeof TemplatesRoute
  '/$id/actions': typeof IdActionsRoute
  '/$id/summarise': typeof IdSummariseRoute
  '/templates/$templateId/edit': typeof TemplatesTemplateIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/templates': typeof TemplatesRoute
  '/$id/actions': typeof IdActionsRoute
  '/$id/summarise': typeof IdSummariseRoute
  '/templates_/$templateId/edit': typeof TemplatesTemplateIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$'
    | '/templates'
    | '/$id/actions'
    | '/$id/summarise'
    | '/templates/$templateId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$'
    | '/templates'
    | '/$id/actions'
    | '/$id/summarise'
    | '/templates/$templateId/edit'
  id:
    | '__root__'
    | '/'
    | '/$'
    | '/templates'
    | '/$id/actions'
    | '/$id/summarise'
    | '/templates_/$templateId/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SplatRoute: typeof SplatRoute
  TemplatesRoute: typeof TemplatesRoute
  IdActionsRoute: typeof IdActionsRoute
  IdSummariseRoute: typeof IdSummariseRoute
  TemplatesTemplateIdEditRoute: typeof TemplatesTemplateIdEditRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/templates': {
      id: '/templates'
      path: '/templates'
      fullPath: '/templates'
      preLoaderRoute: typeof TemplatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$id/summarise': {
      id: '/$id/summarise'
      path: '/$id/summarise'
      fullPath: '/$id/summarise'
      preLoaderRoute: typeof IdSummariseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$id/actions': {
      id: '/$id/actions'
      path: '/$id/actions'
      fullPath: '/$id/actions'
      preLoaderRoute: typeof IdActionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/templates_/$templateId/edit': {
      id: '/templates_/$templateId/edit'
      path: '/templates/$templateId/edit'
      fullPath: '/templates/$templateId/edit'
      preLoaderRoute: typeof TemplatesTemplateIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SplatRoute: SplatRoute,
  TemplatesRoute: TemplatesRoute,
  IdActionsRoute: IdActionsRoute,
  IdSummariseRoute: IdSummariseRoute,
  TemplatesTemplateIdEditRoute: TemplatesTemplateIdEditRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
